import { signatureList } from "constants/signature";

const initialState = {
  signatureList: null,
};

const signatureReducer = (state = initialState, action) => {
  switch (action.type) {
    case signatureList:
      return {
        ...state,
        signatureList: action.payload,
      };
    default:
      return state;
  }
};

export default signatureReducer;
